import type { AstroSize } from '../types';

export const ASTRO_SIZE: AstroSize = {
  WIDTH: 94,
  HEIGHT: 94,
};
